import { render } from "./SaidBar.vue?vue&type=template&id=f2a78e5a&scoped=true"
import script from "./SaidBar.vue?vue&type=script&lang=js"
export * from "./SaidBar.vue?vue&type=script&lang=js"

import "./SaidBar.vue?vue&type=style&index=0&id=f2a78e5a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Лейла\\Desktop\\azbcrm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a78e5a"]])

export default __exports__